import {ControlConfig} from "../config";


export function init({start, stop, playback}: ControlConfig, startFn: ()=>void, stopFn: ()=>void, postFn: (author: string |undefined)=>void) {
    start.addEventListener("click", startFn);
    stop.addEventListener("click", stopFn);
    const playbackAudio = playback?.querySelector("audio")
    const nameInput = playback?.querySelector("input")
    const submitButton = playback?.querySelector("button")
    const uploadForm = playback?.querySelector("#uploadForm") as HTMLDivElement

    if (!playback) {
        console.warn("no playback div provided")
    } else{
        if (!playbackAudio){
            console.warn("no <audio> element found in #playback")
        }
        if (!nameInput){
            console.warn("no <input> element found in #playback for name")
        }
        if (!submitButton){
            console.warn("no <button> element found in #playback to submit")
        }
    }

    playbackAudio?.addEventListener("play", (e)=>{
        nameInput?.focus()
    })
    submitButton?.addEventListener("click",()=>{
        postFn(nameInput?.value)
        uploadForm && (uploadForm.style.visibility = "hidden")
    })

    return  {
        initial : () => {
            start.disabled = false;
            stop.disabled = true;
        },
        changeRecordingState : (recording: boolean) => {
            start.disabled = recording;
            stop.disabled = !recording;
        },
        disablePlayback: ()  => {
            playback && (playback.style.visibility = "hidden")
            playbackAudio?.pause();
        },
        enablePlayback: (audio: Blob) => {
            if (playback){
                playback.style.visibility = "visible"
                const url = URL.createObjectURL(audio);
                playbackAudio && (playbackAudio.src = url)
                uploadForm && (uploadForm.style.visibility = "visible")
            }

        }


    }
}


